import React, { use } from "react";
import { useNavigate, useParams } from "react-router";
import { useGet, usePost } from "../../api";
import { IMerchantSimple, IStartTask, ITaskSimple } from "../../interfaces";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Row,
} from "react-bootstrap";

const validationSchema = yup.object({
  merchantId: yup.string().required(),
  countryCode: yup.string().required(),
  domain: yup.string().required(),
});

export const NewTask: React.FC = () => {
  const { merchantId } = useParams<{ merchantId: string }>();
  const createTask = usePost<ITaskSimple, IStartTask>();
  const navigate = useNavigate();
  const { data: merchant } = useGet<IMerchantSimple>(
    merchantId ? `/merchants/${merchantId}` : null
  );

  const formik = useFormik({
    validationSchema,
    initialValues: {
      merchantId: merchantId ?? "",
      countryCode: "",
      domain: "",
    },
    onSubmit: async (values, { setFieldError }) => {
      if (values.merchantId === "") {
        setFieldError("domain", "Merchant ID is required");
      } else {
        const result = await createTask.execute("/tasks", values);
        navigate("/tasks");
      }
    },
  });

  return (
    <div>
      <Row>
        <Col md={6} className="mx-auto">
          <Form noValidate onSubmit={formik.handleSubmit}>
            <legend>Create New Task</legend>
            <FormGroup className="mb-3">
              <FormLabel htmlFor="countryCode">Country Code</FormLabel>
              <FormControl
                value={formik.values.countryCode}
                onChange={formik.handleChange}
                placeholder="US"
                name="countryCode"
                isInvalid={!!formik.errors.countryCode}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.countryCode}
              </Form.Control.Feedback>
            </FormGroup>
            <Button type="submit">Submit</Button>
          </Form>
        </Col>
      </Row>
    </div>
  );
};
